import { buildChildModule } from '@/app/arch/components/crud/CrudRouter';
import SectionGroup from 'Modules/contacard/produto/groups/group-section/routes';

const featureBreadCrumps = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'Conta card',
    disabled: false,
    to: 'contacard.submodules.list',
  },
  {
    text: 'Listar agrupamentos',
    disabled: false,
    to: 'group.list',
  },
];

export default [
  ...buildChildModule({
    name: 'group',
    path: 'group',
    moduleActive: 'contacard',
    subModuleActive: 'produto',
    breadcrumbs: featureBreadCrumps,
    moduleGroupName: 'productGroup',
    overrideChildProps: false,
    card: {
      title: 'Listar agrupamentos',
      icon: 'home',
    },
    listRoute: {
      pageContent: () => import('Modules/contacard/produto/groups/ProdutoGroupList.vue'),
      pageTitle: 'Listar agrupamentos',
      btnText: 'Adicionar agrupamentos',
      newRouteName: 'group.new',
      navigateBackRoute: 'contacard.submodules.list',
    },
    newRoute: {
      component: () => import('Modules/contacard/produto/groups/ProdutoGroupForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar agrupamento',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('Modules/contacard/produto/groups/ProdutoGroupForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar agrupamento',
          disabled: true,
        },
      ],
    },
    childrens: [
      ...SectionGroup,
    ],
  }),
];
